import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ghorami from "../../../images/songjukti_logo.png";
import { tokens } from "../../../store/tokens";

const ChatBox = ({ pic, logo, commesFrom, botOldConversation = [] }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const scrollRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [botOldConversation]);

  const formattedTime = currentTime.toLocaleTimeString();
  const botAvatar = commesFrom === "personal" ? pic ?? logo ?? ghorami : logo ?? pic ?? ghorami;

  // `combinedConversations` used to merge in a `botNewResponse` prop that
  // the parent never actually passed down, then went unused — the render
  // below always mapped over `botOldConversation` directly. Removed the
  // dead variable (and the console.log that came with it) rather than
  // wire up a prop that has no source of truth in the parent.
  return (
    <Box
      ref={scrollRef}
      sx={{
        flex: 1,
        overflowY: "auto",
        p: 1,
        height: "46vh",
        maxHeight: "calc(65vh - 100px)",
      }}
    >
      {Array.isArray(botOldConversation) &&
        botOldConversation.map((element, index) => {
          const timestamp = element.timestamp ?? formattedTime;
          const key = element.id ?? index;

          return (
            <React.Fragment key={key}>
              {element.message && (
                <Stack direction="row" justifyContent="right" alignItems="center" spacing={1} mb={2}>
                  <Stack spacing={0.2} sx={{ maxWidth: "60%" }} alignItems="flex-end">
                    <Box sx={{ bgcolor: tokens.color.tealLight, padding: "6px 10px", borderRadius: `${tokens.radius.sm}px` }}>
                      <Typography variant="body2" sx={{ color: tokens.color.ink }}>
                        {element.message}
                      </Typography>
                    </Box>
                    <Typography variant="caption" sx={{ color: tokens.color.inkFaint }}>
                      {timestamp}
                    </Typography>
                  </Stack>
                  <Box component="img" sx={{ height: 35, width: 35, borderRadius: "50%" }} alt="You" src={ghorami} />
                </Stack>
              )}

              {element.response && (
                <Stack direction="row" justifyContent="left" alignItems="flex-start" spacing={1} mb={2}>
                  <Box component="img" sx={{ height: 35, width: 35, borderRadius: "50%" }} alt="Bot" src={botAvatar} />
                  <Stack spacing={0.2} sx={{ maxWidth: "50%" }}>
                    <Box sx={{ bgcolor: tokens.color.surfaceMuted, padding: "6px 10px", borderRadius: `${tokens.radius.sm}px` }}>
                      <Typography variant="body2" sx={{ color: tokens.color.ink }}>
                        {element.response}
                      </Typography>
                    </Box>
                    <Typography variant="caption" sx={{ color: tokens.color.inkFaint }}>
                      {timestamp}
                    </Typography>
                  </Stack>
                </Stack>
              )}
            </React.Fragment>
          );
        })}
    </Box>
  );
};

export default ChatBox;
